<template>
   <div id="app">
      <map-print-modal
         :language-is-english="languageIsEnglish"
      />
      <loading-modal v-if="showLoadingModal"/>
      <about-modal
         :language-is-english="languageIsEnglish"
         :show="showAboutModal"
         @change-show="val => showAboutModal=val"
      />
      <app-header
         :language-is-english="languageIsEnglish"
         v-on:toggle-language="toggleLanguage"
         @show-about="showAboutModal=true"
      />
      <router-view
         :language-is-english="languageIsEnglish"
      />
      <app-footer/>
   </div>
</template>

<script>
import Header from './components/Header';
import LoadingModal from './components/LoadingModal';
import MapPrintModal from './components/MapPrintModal';
import AppFooter from './components/Footer';
import AboutModal from './components/AboutModal';
import { bus } from './main';
import { startTour } from './js/introjs';

export default {
   name: 'app',
   data()
   {
      return {
         languageIsEnglish: true,
         showLoadingModal: false,
         showAboutModal: true,
      };
   },
   components: {
      'app-header': Header,
      'loading-modal': LoadingModal,
      'map-print-modal': MapPrintModal,
      'app-footer': AppFooter,
      AboutModal,
   },
   created()
   {
      bus.$on('show-loading-modal', () => this.showLoadingModal = true);
      bus.$on('hide-loading-modal', () => this.showLoadingModal = false);
   },
   mounted()
   {
      bus.$on('start-intro', () =>
      {
         startTour({inEnglish: this.languageIsEnglish});
      });
   },
   methods: {
      toggleLanguage()
      {
         this.languageIsEnglish = !this.languageIsEnglish;
         bus.$emit('language-changed', this.languageIsEnglish ? 'english': 'nepali');
      }
   }
}
</script>

<style lang='scss'>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');
@import './assets/scss/customizations/element-ui.scss';
@import './assets/css/style.css';

#app {
   background-image: linear-gradient(to left, rgb(220, 235, 226), rgb(232, 233, 219));
   display: grid;
   grid-template-rows: auto minmax(300px, 1fr) auto;
   min-height: 100vh;
}

button {
   cursor: pointer !important;
}
.custom-intro-tooltip {
   background: white;
}

/* width */
::-webkit-scrollbar {
   width: 8px;
   height: 8px;
   /* display: none; */
}

/* track */
::-webkit-scrollbar-track {
   opacity: 0;
   /* background: #ddd0; */
}

/* Handle */
::-webkit-scrollbar-thumb {
   background: rgba(170, 170, 170, 0.5);
   background-clip: padding-box;
   border: 1px solid #0000;
   border-radius: 4px;
}

/* Handle on hover  */
::-webkit-scrollbar-thumb:hover {
   background: rgba(153, 153, 153, 0.397);
}

</style>
